export enum VisitStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  EXPIRED = 'EXPIRED',
}

export const VisitStatusLabels: Record<VisitStatus, string> = {
  [VisitStatus.PENDING]: 'Pendiente',
  [VisitStatus.COMPLETED]: 'Entregado',
  [VisitStatus.CANCELLED]: 'Cancelado',
  [VisitStatus.FAILED]: 'Fallido',
  [VisitStatus.EXPIRED]: 'Expirado',
};

export const VisitStatusColors: Record<
  VisitStatus,
  { backgroundColor: string; ballColor: string; textColor: string }
> = {
  [VisitStatus.PENDING]: {
    backgroundColor: '#DBEAFE',
    ballColor: '#3B82F6',
    textColor: '#1E40AF',
  },
  [VisitStatus.COMPLETED]: {
    backgroundColor: '#D1FAE5',
    ballColor: '#10B981',
    textColor: '#10B981',
  },
  [VisitStatus.CANCELLED]: {
    backgroundColor: '#FEE2E2',
    ballColor: '#EF4444',
    textColor: '#EF4444',
  },
  [VisitStatus.FAILED]: {
    backgroundColor: '#FEE2E2',
    ballColor: '#EF4444',
    textColor: '#EF4444',
  },
  [VisitStatus.EXPIRED]: {
    backgroundColor: '#F3F4F6',
    ballColor: '#6B7280',
    textColor: '#6B7280',
  },
};

